
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/juttichoo",
      function () {
        return require("private-next-pages/case-study/juttichoo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/juttichoo"])
      });
    }
  